import axios from "axios";
import base from "@/common/base";
import fileDownload from "js-file-download";
const cdnUrl = __CDN_URL__;
const userR2Url = __USER_R2_URL__;
// 生成区间内的随机数
export function getRandom(max, min) {
  const alp = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
  ];
  const random_int =
    Math.floor(Math.random() * (max - min) + min) +
    alp[(Math.random() * 52).toFixed(0)];
  return random_int;
}

/**
 * 将base64转为blob
 * @param base64 图片base64编码
 * @param name 图片名称
 * @returns {Blob}
 */
export function changeBase64ToBlob(base64, name) {
  let base64Arr = base64.split(",");
  console.log(base64Arr);
  let imgType = "";
  let base64String = "";
  if (base64Arr.length > 1) {
    // 去掉图片base64头信息
    base64String = base64Arr[1];
    imgType = base64Arr[0].substring(
      base64Arr[0].indexOf(":") + 1,
      base64Arr[0].indexOf(";")
    ); // 获取图片类型
  }
  // 将base64解码，atob() 方法用于解码使用 base-64 编码的字符串。
  let bytes = atob(base64String);
  let bytesCode = new ArrayBuffer(bytes.length);
  // 转换为类型化数组，Uint8Array 数组类型表示一个8位无符号整型数组，创建时内容被初始化为0。创建完后，可以以对象的方式或使用数组下标索引的方式引用数组中的元素。
  let byteArray = new Uint8Array(bytesCode);
  // 将base64转换为ascii码
  for (let i = 0; i < bytes.length; i++) {
    byteArray[i] = bytes.charCodeAt(i); // 对类型化数组进行赋值
  }
  let blobData = new Blob([bytesCode], {
    type: imgType,
  });
  console.log(blobData);
  let imgSuffix = "." + imgType.split("/")[1]; // 获取图片后缀
  console.log(imgSuffix);
  let imageFile = new File([blobData], name + imgSuffix); // 将blob转换为file类型
  return imageFile;
}

/**
 * 获取bas464 URL
 * @param {*} url 文件url
 * @param {*} prefix 域名前缀
 * @param {*} callback 回调函数 (url: base64)
 */
export const getBase64 = (url, prefix = cdnUrl, callback) => {
  return new Promise((resolve, reject) => {
    let Img = new Image();
    let dataURL = "";
    let str = url.replace(prefix, "");
    str = str.replace("https://img.sharkfoto.com", "/img_sharkfoto_image");
    Img.src = prefix + str + "?v=" + Math.random();
    Img.setAttribute("crossOrigin", "anonymous");
    Img.onload = function () {
      const canvas = document.createElement("canvas");
      const width = Img.width;
      const height = Img.height;
      canvas.width = width;
      canvas.height = height;
      canvas.getContext("2d").drawImage(Img, 0, 0, width, height);
      dataURL = canvas.toDataURL("image/jpeg");
      if (callback) {
        resolve(callback(dataURL));
      } else {
        resolve(dataURL);
      }
    };
    Img.onerror = function (err) {
      console.log("err", err);
      reject(err);
    };
  });
};
/**
 * bas464URL获取文件
 * @param {*} url bas464 URL
 * @param {*} filename 文件名称
 * @returns {File} 文件
 */
export const getFileFromBase64 = (base64URL, filename) => {
  var arr = base64URL.split(","),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {
    type: mime,
  });
};

/**
 * 把图片转成base64 获取图片分辨率
 * @param file 图片input出来的file属性
 * @returns {img_mes} //图片的原始信息
 */
export function fileChangeBase64(file) {
  // let that = this;
  let img = file; //获取到上传文件的对象img_width,img_height;
  let img_mes = {};
  var reader = new FileReader();
  reader.readAsDataURL(img); //参数为上传的文件对象 传值进去就会触发以下onload方法
  reader.onload = function (e) {
    // e.target.result为转换成的base64编码
    var Img = new Image(); //定义一个图片对象
    Img.src = e.target.result; //当src被赋值 则触发以下方法
    Img.onload = function () {
      // 图片的原始信息 大小 宽高 类型 （赋值到data里面）
      // console.log('在获取 原始图片信息 Img.width:', Img.width)
      img_mes = {
        img_size: (file.size / 1024).toFixed(2),
        img_type: file.type.split("/")[1],
        img_width: Img.width + "x" + Img.height,
        width: Img.width,
        height: Img.height,
      };
    };
  };
  return img_mes;
}

/**
 * 防抖函数
 * @param {*} fn 函数
 * @param {*} delay 延迟事件
 * @returns
 */
export const debounce = (fn, delay) => {
  let timer = null;
  return function () {
    clearTimeout(timer);
    let args = Array.prototype.slice.call(arguments);
    timer = setTimeout(() => {
      fn();
    }, delay);
  };
};

/**
 * 对数组|对象进行模糊匹配
 * @param list 数组 | 对象
 * @param keyword 匹配关键词
 * @param attribute 匹配的属性名称
 * @returns {Array} 模糊匹配数组
 */

export const fuzzyMatch = (list, keyword, attribute) => {
  const reg = new RegExp(keyword);
  const arr = [];

  const isObject = Object.prototype.toString.call(list) === "[object Object]";
  if (isObject) {
    list = Object.values();
  }
  if (attribute) {
    for (let i = 0; i < list.length; i++) {
      if (reg.test(list[i][attribute])) {
        arr.push(list[i]);
      }
    }
  } else {
    for (let i = 0; i < list.length; i++) {
      if (reg.test(list[i])) {
        arr.push(list[i]);
      }
    }
  }
};

/**
 * 复制文本到粘贴板
 * @param url 复制的文本
 * @param callback 回调函数
 * @returns {null}
 */
export function copyUrl(url, callback) {
  var input = document.createElement("input");
  document.body.appendChild(input);
  input.setAttribute("value", url);
  input.select();
  document.execCommand("copy"); // 执行浏览器复制命令
  if (document.execCommand("copy")) {
    callback && callback();
  }
  document.body.removeChild(input);
}

export function createRouterLink(href = "") {
  if (!href) return;
  var a = document.createElement("a");
  a.setAttribute("href", href);
  a.setAttribute("id", "startTelMedicine");
  // 防止反复添加
  if (document.getElementById("startTelMedicine")) {
    document.body.removeChild(document.getElementById("startTelMedicine"));
  }
  document.body.appendChild(a);
  a.click();
  // console.log(this.$nuxt)
  // const a = document.createElement('a')
  // window.document.appendChild(a)
  a.setAttribute("src", "/gallery/");
}

/**
 * 获取图片的 base64 编码
 * @param image 图像对象
 * @return {string} 返回已编码的 base64数据
 */
const getImageBase64 = (image) => {
  const canvas = document.createElement("canvas");
  canvas.width = image.width;
  canvas.height = image.height;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(image, 0, 0, image.width, image.height);
  // 获取图片后缀名
  const extension = image.src
    .substring(image.src.lastIndexOf(".") + 1)
    .toLowerCase();
  // 某些图片 url 可能没有后缀名，默认是 png
  return canvas.toDataURL("image/" + extension, 1);
};

/**
 * 单张图片下载
 * @param url 图像链接
 * @param downloadName 图片名称
 */
export const downLoadImg = (imgsrc, name) => {
  var image = new Image();
  // 解决跨域 Canvas 污染问题
  image.setAttribute("crossOrigin", "anonymous");
  image.onload = function () {
    var canvas = document.createElement("canvas");
    canvas.width = image.width;
    canvas.height = image.height;
    var context = canvas.getContext("2d");
    context.drawImage(image, 0, 0, image.width, image.height);
    var url = canvas.toDataURL("image/png", 0.7); //得到图片的base64编码数据
    var a = document.createElement("a"); // 生成一个a元素
    var event = new MouseEvent("click"); // 创建一个单击事件
    a.download = name ? name : "photo"; // 设置图片名称
    a.href = url; // 将生成的URL设置为a.href属性
    a.dispatchEvent(event); // 触发a的单击事件
  };
  image.src = imgsrc;
};

/**
 * 文件 => blob
 * @param file 文件
 */
export const getBlob = (file) => {
  return new Blob([file], {
    type: "audio/wav",
  });
};

export const findIndex = (arr, item, attribute = "") => {
  if (!arr.length) return -1;
  if (!attribute) return arr.indexOf(item);
  let idx = -1;
  arr.map((_i, _idx) => {
    if (item[attribute] === _i[attribute]) {
      idx = _idx;
    }
  });
  return idx;
};

export const findIndexOfValue = (arr, value, attribute) => {
  if (!arr.length) return -1;
  let idx = -1;
  arr.map((_i, _idx) => {
    if (value === _i[attribute]) {
      idx = _idx;
    }
  });
  return idx;
};

export const getRandomStr = (num = 7) => {
  const ori = "AaBbCcDdEeFfGgHhIiJjKkLlMmNnOoPpQqRrSsTtUuVvWwXxYyZz";
  let str = "";
  for (let i = 0; i < num; i++) {
    str += ori[parseInt(Math.random() * ori.length)];
  }
  return str + Date.now();
};
/**
 * 简易版获取 yyyy-mm-dd 格式日期
 * @param {*} separator 分隔符 默认 -
 * @returns yyyy-mm-dd
 */
export const getDateTime = (separator = "-") => {
  const today = new Date();
  const dd = String(today.getDate()).padStart(2, "0");
  const mm = String(today.getMonth() + 1).padStart(2, "0");
  const yyyy = today.getFullYear();
  return `${yyyy}${separator}${mm}${separator}${dd}`;
};

/**
 * 获取当前值在数组中的索引
 * @param {*} list  目标数组
 * @param {*} val   查找值
 * @param {*} field 字段名
 * @returns
 */
export const getIndexOf = (list, val, field) => {
  let idx = -1;
  if (list.length) {
    list.map((item, index) => {
      if (idx !== -1) return;
      if (item[field] === val) {
        idx = index;
      }
    });
  }
  return idx;
};

export const getblobFile = async (blob, filename, filetype) => {
  return new window.File([blob], filename, filetype);
};

export const downloadFile = (url, name, isTemp, signal) => {
  console.log("downloadFile：URL", url, isTemp);

  // 路径替换
  url = url.replace(cdnUrl, "/cdn_sharkfoto_image");
  url = url.replace("https://img.sharkfoto.com", "/img_sharkfoto_image");
  console.log("downloadFile：URL2", url, isTemp);
  url = url.replace(
    userR2Url,
    __CUSTOM_ENV__ === "production"
      ? "/sharkfoto_storage_pro"
      : "/sharkfoto_storage_test"
  );
  url = url.replace(
    "https://pub-a493cbae12d24ee498bfe20e3daa78f6.r2.dev",
    "/sharkfoto_storage_test"
  );
  url = url.replace("https://storage.sharkfoto.com", "/sharkfoto_storage_pro");

  if (!isTemp) {
    return axios
      .get(url, {
        responseType: "blob",
        signal, // ✅ 关键：支持 AbortController
      })
      .then((res) => {
        console.log("downloadFile：Res", res.data);
        fileDownload(res.data, name);
      })
      .catch((err) => {
        if (err && err.response) {
          console.error(
            `downloadFile error: Status ${err.response.status}, ${err.response.statusText}`,
            "Response data:",
            err.response.data
          );
        } else if (err && err.message) {
          console.error("downloadFile error:", err.message, err);
        } else {
          console.error("downloadFile error:", err);
        }
      });
  } else {
    return new Promise((resolve) => {
      const link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.download = name;

      document.body.appendChild(link);
      link.click();

      // 不 revoke 这个 blob: URL —— 它由打开本页的工具页(triggerDownload)创建并持有,
      // /download 只是跨标签页复用。这里 revoke 会把它作废,导致用户在本页「再次下载」失效
      // (net error)。生命周期归工具页:它在下次转换/重置时自行 revoke。(nuxt#32)
      setTimeout(() => {
        link.parentNode.removeChild(link);
        resolve();
      }, 0);
    });
  }
};

export const queryString = {
  /**
   * 把数据序列化为URL参数
   * @method stringify
   * @param {Object|Array<Object<name,value>>} data 数据
   * @param {Object} [o] 参数
   * @param {Function} [o.encode=encodeURIComponent] 编码函数
   * @return {String} URL参数串
   */
  stringify: function (data, o) {
    if (typeof data === "string") {
      return data;
    }

    o = Object.assign(
      {
        encode: encodeURIComponent,
      },
      o
    );

    let result = [];
    if (Array.isArray(data)) {
      data.forEach(function (d) {
        result.push(encode(d.name, d.value, o.encode));
      });
    } else {
      for (let name in data) {
        result.push(encode(name, data[name], o.encode));
      }
    }

    return result.join("&");
  },
  /**
   * 把URL参数反序列化为数据
   * @method parse
   * @param {String} [qs] URL参数，默认为当前窗口的location.search
   * @param {Object} [o] 参数
   * @param {Function} [o.decode=decodeURIComponent] 解码函数
   * @param {String} [o.dataType] 返回数组类型，默认为Object，参数值为'array'时返回数组
   * @return {Object|Array<Object<name,value>>} 数据
   */
  parse: function (qs, o) {
    o = base.extend(
      {
        decode: decodeURIComponent,
      },
      o
    );

    let returnArray = o.dataType === "array";
    let data = returnArray ? [] : {};

    qs = (qs || window.location.search.substr(1))
      .replace(/(?:^|&)([^&]+)=([^&]+)/g, function ($0, $1, $2) {
        let value = $2;
        try {
          value = o.decode(value);
        } catch (e) { }
        if (returnArray) {
          data.push({
            name: $1,
            value: value,
          });
        } else {
          data[$1] = value;
        }
        return "";
      })
      .split("&");

    for (let i = 0; i < qs.length; i++) {
      if (qs[i]) {
        if (returnArray) {
          data.push({
            name: qs[i],
            value: null,
          });
        } else {
          data[qs[i]] = null;
        }
      }
    }

    return data;
  },
};

/**
 * 锚点跳转
 * @param {*} selector 选择器
 * @param {*} behavior 行为
 */
export const goAnchor = (selector, behavior = "smooth") => {
  setTimeout(() => {
    let anchor = document.querySelector(selector);
    anchor.scrollIntoView({
      behavior,
    });
  }, 500);
};

/**
 * 获取随机rgb
 * @returns {<style: Background>}
 */
export const randomRgb = () => {
  let R = Math.floor(Math.random() * 130 + 110);
  let G = Math.floor(Math.random() * 130 + 110);
  let B = Math.floor(Math.random() * 130 + 110);
  return {
    background: "rgb(" + R + "," + G + "," + B + ", .5)",
  };
};

/**
 * 格式化图片列表
 * @param {*} list
 * @returns {Array}
 */
export const formatImageList = (list, prefix = cdnUrl + "/gallery") => {
  if (list && list.length) {
    list.map((i) => {
      const randomBg = randomRgb();
      i.src =
        prefix +
        (i.bgremove_prview_path || i.bgremove_path) +
        "?image_process=resize,w_320";
      i.href = "/gallery/" + i.pslug + "-" + i.gallery_image_id + "/";
      i.detailUrl = `${prefix}/` + i.pslug + "-" + i.gallery_image_id + "/";
      i.background = randomBg;
      i.id = i.gallery_image_id;
      (i.srcset = `${prefix}${i.bgremove_path}?image_process=resize,w_320 320w, ${prefix}${i.bgremove_path}?image_process=resize,w_260 260w`),
        (i.lazySrcset = `${prefix}${i.bgremove_path}?image_process=resize,w_320 320w &=, ${prefix}${i.bgremove_path}?image_process=resize,w_260 260w`);
      i.sizes = `(max-width: 807px) calc((100vw - 40px - 36px) / 2), (max-width: 1106px) calc((100vw - 40px - 48px) / 3), 304px`;
    });
  }
  return list || [];
};

/**
 * 切割图片列表
 * @param {*} list 原始大小
 * @param {*} size 大小
 * @returns {Object}(imageList: <Array>, extraList: <Array>)
 */
export const splitImageArr = (list, size) => {
  const len = list.length;
  let _list = [],
    extra = [];
  if (len > size) {
    _list = list.slice(0, size);
    extra = list.slice(size);
  } else {
    _list = list;
  }
  return {
    imageList: _list,
    extraList: extra,
  };
};

export const isIncludesFormat = (list, format) => {
  return list.includes(format.toUpperCase());
};

/**
 * 比较浮点数, num1 > num2 ?
 * @param {*} num1
 * @param {*} num2
 * @returns {Boolean}
 */
export const compareFloatNum = (num1, num2) => {
  return Math.abs(num1 - num2) > 0.0001;
};

/**
 * 解码JWT token
 * @param {string} token JWT token字符串
 * @returns {object|null} 解码后的payload对象，失败返回null
 */
export function decodeJWT(token) {
  try {
    // JWT格式: header.payload.signature
    const base64Url = token.split(".")[1];
    if (!base64Url) {
      console.error("Invalid JWT token format");
      return null;
    }

    // Base64解码（需要处理URL安全的Base64编码）
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => {
          return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join("")
    );

    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error("Failed to decode JWT:", error);
    return null;
  }
}

/**
 * 从Google JWT token中提取用户头像URL
 * @param {string} jwtToken Google登录返回的JWT token
 * @returns {string|null} 头像URL，如果不存在则返回null
 */
export function getGoogleAvatarFromJWT(jwtToken) {
  try {
    const decoded = decodeJWT(jwtToken);
    if (decoded && decoded.picture) {
      return decoded.picture;
    }
    return null;
  } catch (error) {
    console.error("Failed to get Google avatar:", error);
    return null;
  }
}

/**
 * 从Google JWT token中提取用户信息（包括头像）
 * @param {string} jwtToken Google登录返回的JWT token
 * @returns {object|null} 包含name, email, picture等的用户信息对象
 */
export function getGoogleUserInfoFromJWT(jwtToken) {
  try {
    const decoded = decodeJWT(jwtToken);
    if (decoded) {
      return {
        name: decoded.name || null,
        email: decoded.email || null,
        picture: decoded.picture || null,
        given_name: decoded.given_name || null,
        family_name: decoded.family_name || null,
      };
    }
    return null;
  } catch (error) {
    console.error("Failed to get Google user info:", error);
    return null;
  }
}

/**
 * 从Apple登录回调中获取用户信息
 * 注意：Apple出于隐私考虑，不会提供头像URL，只返回用户ID和邮箱（如果用户授权）
 * @param {object} payload Apple登录成功的payload对象
 * @returns {object|null} 包含用户信息的对象（不包含头像）
 */
export function getAppleUserInfo(payload) {
  try {
    const user = payload?.detail?.user || {};
    const authorization = payload?.detail?.authorization || {};

    // Apple不提供头像，但可以提供邮箱和名称
    return {
      email: user.email || null,
      name: user.name || null,
      // Apple不提供头像URL
      picture: null,
      userId: user.id || null,
    };
  } catch (error) {
    console.error("Failed to get Apple user info:", error);
    return null;
  }
}
